export const messages = {
  en: {
    housekeepingServPoolPay: {
      title: 'Service Payment',
      queryConditions: 'Query Conditions',
      serviceName: 'Service Name',
      applicant: 'Applicant',
      contactNumber: 'Contact Number',
      search: 'Search',
      reset: 'Reset',
      orderNumber: 'Order Number',
      contactInfo: 'Contact Info',
      appointmentTime: 'Appointment Time',
      applicationTime: 'Application Time',
      status: 'Status',
      remarks: 'Remarks',
      operations: 'Operations',
      pay: 'Pay',
      details: 'Details',
      phoneReservation: 'Phone Reservation'
    }
  },
  zh: {
    housekeepingServPoolPay: {
      title: '服务支付',
      queryConditions: '查询条件',
      serviceName: '服务名称',
      applicant: '申请人',
      contactNumber: '联系电话',
      search: '查询',
      reset: '重置',
      orderNumber: '订单编号',
      contactInfo: '联系方式',
      appointmentTime: '预约时间',
      applicationTime: '申请时间',
      status: '状态',
      remarks: '备注',
      operations: '操作',
      pay: '缴费',
      details: '详情',
      phoneReservation: '电话预约'
    }
  }
}